import { AppBaseDataService } from './_services/app-base-data.service';
import { UserService } from 'src/app/_services/user.service';
import { Component, HostListener, Inject } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { WHITE_LABEL, WhiteLabelList } from './_data/white-label-list';
import { GlobalService } from './_services/global.service';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser'
import { FilterServiceService } from './_services/filter-service.service';
import { filter, map, mergeMap, Subject, lastValueFrom } from 'rxjs';
import { StepService } from './_services/step.service.service';
import { PlanDataService } from './_services/plan-data.service';
import { SignupService } from './_services/signup.service';
import { environment } from 'src/environments/environment';
import { SingleTabGuardService } from './_services/single-tab-guard.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
    _globals = GlobalService
    menuMode = 'static';
    dialogTimeInterval: any

    constructor(private primengConfig: PrimeNGConfig,
        public _userService: UserService,
        public _abd: AppBaseDataService,
        private _router: Router,
        private title: Title,
        private _activatedRoute: ActivatedRoute,
        private _filterService: FilterServiceService,
         private stepService: StepService,
         private signupService: SignupService,
         private _planData: PlanDataService,
        public singleTabGuard: SingleTabGuardService,
        @Inject(DOCUMENT) private _document: HTMLDocument) {
        this.singleTabGuard.init();
        this.setTimeout();
        this.userInactive.subscribe(res => {
            // debugger;
            if (!this.displayUserInactivity && !window.location.href.includes('/pages/signin')) {
                this.displayUserInactivity = true
                this.userDialogTimer = 60
                clearTimeout(this.userActivityTimer)

                this.dialogTimeInterval = setInterval(() => {
                    this.userDialogTimer--
                    if (this.userDialogTimer <= 0) {
                        const xx = window.location.href
                        this.displayUserInactivity = false
                        clearInterval(this.dialogTimeInterval)
                        localStorage.clear();
                        location.reload();
                        this._router.navigate([''])
                    } else {

                    }

                }, 1000);
            }
        });

        _router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if (event.id == 1) {
                    //let last = localStorage.getItem('goto')
                }
                else {
                    let href = window.location.href
                    if (!href.includes('%')) {
                        let x = window.location.origin + '/#' + event.url
                        if (this.isAllowedToSave(x)) {
                            const old = localStorage.getItem('goto')
                            localStorage.setItem('goto', x)
                            if (old && old !== x)
                                this._filterService.RestFiltersandPages()
                        }
                    }
                }
            }
            else if (event instanceof NavigationEnd) {
                this.updateZendeskWidgetVisibility(event.urlAfterRedirects)
            }
        })
    } //-- end constructor

    // Zendesk (index.html) loads once for the SPA's lifetime, so route/role-based visibility
    // has to be applied at runtime via the widget's own API rather than by conditioning the
    // script tag itself. Hidden on the dashboard-v2 landing page and for the internal admin
    // role (_abd.isAdmin) — shown everywhere else.
    private zendeskWantsVisible: boolean | null = null;
    private zendeskReadyPoll: any = null;

    private updateZendeskWidgetVisibility(url: string): void {
        const isDashboardV2 = /dashboard-v2/i.test(url || '');
        this.setZendeskWidgetVisible(!isDashboardV2 && !this._abd.isAdmin);
    }

    private setZendeskWidgetVisible(show: boolean): void {
        this.zendeskWantsVisible = show;
        const zE = (window as any).zE;
        if (typeof zE === 'function') {
            zE('messenger', show ? 'show' : 'hide');
            return;
        }
        if (this.zendeskReadyPoll) return;
        this.zendeskReadyPoll = setInterval(() => {
            const fn = (window as any).zE;
            if (typeof fn === 'function') {
                clearInterval(this.zendeskReadyPoll);
                this.zendeskReadyPoll = null;
                fn('messenger', this.zendeskWantsVisible ? 'show' : 'hide');
            }
        }, 300);
    }
    isAllowedToSave(href: string) {
        const notAllowed = [
            '/app/new-product',
            '/app/transfer-out-form',
            '/app/transfers-receive-form',
            '/app/customer-details',
            '/app/purchase-orders-create-edit',
            '/app/purchase-orders-receive-open',
            '/app/purchase-orders-closed',
            '/app/users-new-edit',
            '/purchase-orders-receive-open',
            '/app/sales-invoice-detail',
            'app/purchase-orders-receive-closed-for-receiving',
            '/app/purchase-orders-receive-direct',
            '/select-template',
            'template-preview',
        ]
        let found = false
        for (let i = 0; i < notAllowed.length; i++) {
            if (href.includes(notAllowed[i])) {
                found = true
                break
            }
        }
        return !found
    }
    ngOnInit() {
        // Dev-only console hook so trial-lockout/plan-expiry state (GlobalService.userInfo,
        // in-memory only — never persisted to localStorage) can be mutated directly from
        // DevTools instead of intercepting the B2CGraphClientApi network response, e.g.:
        //   __glob.userInfo.businessSetup[0].isFreeTrial = true;
        //   __glob.userInfo.businessSetup[0].freeTrialEndDate = new Date(Date.now() - 86400000).toISOString();
        //   location.reload();
        if (!environment.production) {
            (window as any).__glob = GlobalService;
        }
        this.primengConfig.ripple = true;
        if(this._globals.whiteLabel == null || this._globals.whiteLabel == undefined){
            const wl = localStorage.getItem('whiteLabel') || 'linc';
            this._globals.whiteLabel = WhiteLabelList[0];
        }
        document.documentElement.style.fontSize = '14px';
        const fullHash = decodeURIComponent(window.location.hash || '');               // e.g. "#/signup/personal-info?selectedplan=3&interval=y"
        const [path, queryString] = fullHash.split('?');     // split on "?"
        // Only signup deep links (which carry plan-selection params handled below) should skip
        // autologin() — any other route with a query string (e.g. "/app/business?page=shipping")
        // was previously skipping autologin() too, which meant login-state was never checked and
        // the page was left blank forever since nothing else redirects an unauthenticated visitor.
        const isSignupDeepLink = /^\/?signup/i.test(path || '');
        if (!queryString || !isSignupDeepLink) {
            this._userService.autologin()
        }

        const params = new URLSearchParams(queryString);
        const packed = this.parsePackedData(params.get('data'));
        const sp = this.decodeParam(params.get('selectedplan') ?? params.get('plan') ?? packed?.plan ?? null);
       
      
        const hashRaw = window.location.hash || '';
        const hashDecoded = decodeURIComponent(hashRaw);
        let href = hashDecoded


        if (href.includes('/handheld')) localStorage.setItem('whichRoute', 'handheld')
        else localStorage.setItem('whichRoute', 'any')
        try {
            let favIcon: HTMLLinkElement = document.querySelector('#appFavicon');
            favIcon.href = "assets/images/" + this._globals.whiteLabel.favIcon + ".ico";
            // favIcon.href = "assets/images/favicon-cbd.ico";
        }
        catch
        {
        }

        document.documentElement.style.setProperty('--brandColor', this._globals.whiteLabel.themeData.brandColor);
        document.documentElement.style.setProperty('--brandColorDark', this._globals.whiteLabel.themeData.brandColorDark);
        document.documentElement.style.setProperty('--brandColorLight', this._globals.whiteLabel.themeData.brandColorLight);
        document.documentElement.style.setProperty('--bs-primary', this._globals.whiteLabel.themeData.brandColor);
        document.documentElement.style.setProperty('--brandSecondaryColor', "#171046");
      
        if (!queryString) return;
        
        const iv = this.decodeParam(params.get('interval') ?? packed?.interval ?? null);

         const trackingId = this.decodeParam(params.get('trackingId') ?? params.get('coupon') ?? packed?.trackingId ?? null);
         const emailParam = this.decodeParam(params.get('email') ?? packed?.email ?? null);

        if (sp && iv) {

            const parseToInt = parseInt(sp);
        
            const defaultPlan = this._planData.list.find(f=> f.id == parseToInt);
            this.stepService.setBrowseUsingLincsellWebsite(true)
            this.stepService.setSelectedPlanId(parseToInt)
      

            this.stepService.setBillingInterval(iv == 'm'? "monthly": "yearly")
            sessionStorage.setItem('billing-interval-info', JSON.stringify(iv == 'm'? "monthly": "yearly"));
            this.stepService.setUserSelectedPlan(defaultPlan)
            sessionStorage.setItem('selected-plan-info', JSON.stringify(defaultPlan))
            if(emailParam && this.stepService.isValidEmail(emailParam)){
                sessionStorage.setItem('prefill-email', emailParam);
                
            }

            sessionStorage.setItem('selected_plan_id', sp);
            sessionStorage.setItem('interval', iv);
            sessionStorage.setItem('url_plan_selected', "1");
            if(trackingId != undefined && trackingId != null){
                sessionStorage.setItem('url_coupon_code', trackingId);
            }
            
        }

        // If email is passed in URL, set prefill and, on first visit, validate existence to redirect if needed
        if (emailParam && this.stepService.isValidEmail(emailParam)) {
            if (!sessionStorage.getItem('prefill-email')) {
                sessionStorage.setItem('prefill-email', emailParam);
            }
            this.handlePrefillEmail(emailParam);
        }

        this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateViewport(event.urlAfterRedirects);
      });

    }

     private updateViewport(_url: string): void {
        const viewport = document.querySelector('meta[name=viewport]');
        if (!viewport) return;

        // Always use responsive viewport so mobile screens render correctly
        viewport.setAttribute('content', 'width=device-width, initial-scale=1');
    }

    private decodeParam(value: string | null): string | null {
        if (value === null || value === undefined) return null;
        try {
            return decodeURIComponent(value);
        } catch {
            return value;
        }
    }

    private decodePackedPayload(raw: string | null): string | null {
        if (!raw) return null;
        const decoded = this.decodeParam(raw);
        if (!decoded) return null;
        try {
            return atob(decoded);
        } catch {
            return decoded;
        }
    }

    private parseQueryString(query: string): Record<string, string> {
        return query.split('&').reduce((acc: Record<string, string>, part) => {
            if (!part) return acc;
            const [key, ...rest] = part.split('=');
            if (!key) return acc;
            const k = this.decodeParam(key) || key;
            const v = this.decodeParam(rest.join('=')) || '';
            acc[k] = v;
            return acc;
        }, {});
    }

    /**
     * If email is provided from URL and exists already, redirect to login with the email prefilled.
     * Runs only once per session to avoid loops.
     */
    private async handlePrefillEmail(email: string): Promise<void> {
        if (!email || !this._globals.isValidEmail(email)) return;
        if (sessionStorage.getItem('prefill-email-checked') === '1') return;

        sessionStorage.setItem('prefill-email-checked', '1');
        try {
            const res: any = await lastValueFrom(this.signupService.isUserExist(email));
            if (res?.success && res?.data) {
                // Existing user: redirect to login with email prefilled
                this._router.navigate(['/pages/signin'], {
                    queryParams: { email }
                });
            }
        } catch {
            // On error, do nothing; user can proceed to signup
        }
    }

    private parsePackedData(raw: string | null): { plan: string | null; interval: string | null; email: string | null; trackingId: string | null } | null {
        const payload = this.decodePackedPayload(raw);
        if (!payload) return null;

        if (payload.includes('?')) {
            const query = payload.split('?')[1] || '';
            const params = this.parseQueryString(query);
            return {
                plan: params['selectedplan'] ?? params['selectedPlan'] ?? params['plan'] ?? params['planId'] ?? null,
                interval: params['interval'] ?? null,
                email: params['email'] ?? params['Email'] ?? params['username'] ?? null,
                trackingId: params['trackingId'] ?? params['coupon'] ?? params['couponCode'] ?? null
            };
        }

        if (payload.includes('|')) {
            const parts = payload.split('|').map(p => p?.trim() || '');
            return {
                plan: parts[0] || null,
                interval: parts[1] || null,
                email: parts[2] || null,
                trackingId: parts[3] || null
            };
        }

        return null;
    }

    async setCurrentUser() {
        const model = JSON.parse(localStorage.getItem('user'));
        const isTokenValid = this._userService.isUserTokenExpired()
        if (model && !isTokenValid && this._userService.isUserAutoLogin()) {
            // Token is still valid; restore user without forcing logout
            await this._userService.setCurrentUser(model)
            this._userService.setUserTokenExpiryTime()
            return
        }

        // else clear localstorage data
        this._userService.logout()
    }

    displayUserInactivity = false
    userActivityMins = 30;
    userActivityInMilliSec = this.userActivityMins * 60 * 1000
    userActivityTimer: any
    userInactive: Subject<any> = new Subject();
    userDialogTimer = 60
    waitingForRefreshToken = false

    setTimeout() {
        // console.log('in time out')
        this.userActivityTimer = setTimeout(() => this.userInactive.next(undefined), this.userActivityInMilliSec);

        const today = Date.now()
        let xx = localStorage.getItem('lastLoginDT')

        if (!xx) return
        const dt = (new Date(Number(xx))).getTime()

        if (today > dt && !this.waitingForRefreshToken) {

            const obj = JSON.parse(localStorage.getItem('user'));
            if (!obj) return

            this.waitingForRefreshToken = true
            this._userService.getRefreshToken({
                "RefreshToken": obj.refreshToke
            }).subscribe(res => {
                if (res.success) {

                    let user = JSON.parse(localStorage.getItem('user'))
                    user.token = res.data.access_token
                    user.refreshToke = res.data.refresh_token
                    user.expires_in = res.data.expires_in

                    this._userService.setCurrentUser(user)

                    this.waitingForRefreshToken = false
                }
            })

        } //else console.log('todayyyyy', today, dt)
    }

    clearAutologoffHandle() {
        this.displayUserInactivity = false
        clearInterval(this.dialogTimeInterval)
        clearTimeout(this.userActivityTimer);
        this.setTimeout()
    }

    @HostListener('document:mousemove') refreshUserStateMouse() {
        clearTimeout(this.userActivityTimer);
        this.setTimeout();
    }

    @HostListener('document:keydown') refreshUserStateKeydown() {
        clearTimeout(this.userActivityTimer);
        this.setTimeout();
    }

    @HostListener('document:touchstart') refreshUserStateTouch() {
        clearTimeout(this.userActivityTimer);
        this.setTimeout();
    }

    // @HostListener('document:click') refreshUserStateClick() {
    //     // console.log('Clicked')
    // //     let userAttendance = localStorage.getItem('userAttendance')
    // //    let userCheckInType = localStorage.getItem('userCheckInType')
    // //   let enableTimeAttendance = localStorage.getItem('enableTimeAttendance')
    // //  if(enableTimeAttendance === 'true'){
    // //       if(userAttendance === 'not-check-in' && userCheckInType === 'force-checkIn'){
    // //         this._userService.isShowCheckIn = true
    // //         if(this._userService.isCheckIn === false){
    // //            this._userService.isCheckIn = true
    // //     }
    // //  }
    // //  }

    // }


}
